import { MenuItemProps as MenuItem } from '@rio-cloud/rio-uikit/MenuItem';
import SimpleButtonDropdown from '@rio-cloud/rio-uikit/SimpleButtonDropdown';
import { connect } from 'react-redux';

import { DownloadStatePart } from '../../setup/types';
import { isDownloading } from './selectors';

type Props = {
    options: MenuItem[];
    isDownloading: boolean;
    disabled?: boolean;
    owner: 'vehicle' | 'driver';
};

export const DownloadMenu = ({
    options = [],
    isDownloading,
    disabled = false,
    owner,
}: Props): JSX.Element => {
    if (isDownloading) {
        return <button className="btn btn-default btn-icon-only btn-loading" />;
    }
    const elementName = owner === 'vehicle' ? 'fleetAnalysis' : 'drivingAnalysis';
    return (
        <SimpleButtonDropdown
            disabled={disabled}
            items={options}
            title={
                <span
                    data-test="toolbar-download"
                    data-track-ga-event-trigger="click"
                    data-track-ga-event-name="perform_report_downloaded"
                    data-track-ga-event-element-name={elementName}
                    className="rioglyph rioglyph-download"
                    aria-hidden="true"
                />
            }
            iconOnly
            pullRight
            dropdownClassName="width-300"
        />
    );
};

export default connect((state: DownloadStatePart, { owner }: { owner: string }) => ({
    isDownloading: isDownloading(state, owner),
}))(DownloadMenu);
